import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Input, Tabs, Checkbox, Badge, Row, Col, Modal, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import useDocTitle from '@/hooks/useDocTitle.mjs';
import { useUser } from '@/biz/user.mjs'
import BasMapTab from './BasMapTab.jsx';
import BfTab from './BfTab.jsx';
import BdTab from './BdTab.jsx';
import SfTab from './SfTab.jsx';
import UcTab from './UcTab.jsx';
import UiTab from './UiTab.jsx';
import DtTab from './DtTab.jsx';
import DvTab from './DvTab.jsx';
import CdgTab from './CdgTab.jsx';
import LsiTab from './LsiTab.jsx';
import FcTab from './FcTab.jsx';
import DtoTab from './DtoTab.jsx';
import DesTab from './DesTab.jsx';
import OoTab from './OoTab.jsx';
import DoTab from './DoTab.jsx';
import AoTab from './AoTab.jsx';
import AiTab from './AiTab.jsx';
import ArTab from './ArTab.jsx';
import RmTab from './RmTab.jsx';
import SelectPattern from './SelectPattern.jsx';
import SelectBaseline from './SelectBaseline.jsx';

const NEWS = ['NEW', 'BM', 'DM', 'BCT', 'LIB'];
const OM = 'OM';
const BAM = 'BAM';
const TAM = 'TAM';

const Pane = () => {
    useDocTitle('搜索');
    const [searchParams] = useSearchParams()
    const param = Object.fromEntries(searchParams.entries());
    const keyword = param.keyword;

    const { TabPane } = Tabs;
    const http = useHTTP();
    const user = useUser();
    const ref = useRef({ count: 0, prjTypeCode: user?.prjTypeCode });
    const [prj, setPrj] = useState({});

    // const isBoda2 = 'BODA2' == ref.current.subTypeCode;
    // const bdName = isBoda2 ? '程序模块' : '业务能力模块';

    // -----------------------List-----------------------
    const [bfMapList, setBfMapList] = useState([]);
    const [bizMapList, setBizMapList] = useState([]);
    const [dataMapList, setDataMapList] = useState([]);
    const [sfMapList, setSfMapList] = useState([]);
    const [uiMapList, setUiMapList] = useState([]);
    const [infMapList, setInfMapList] = useState([]);
    const [fcMapList, setFcMapList] = useState([]);
    const [orgMapList, setOrgMapList] = useState([]); // 组织地图
    const [anaMapList, setAnaMapList] = useState([]); // 分析地图

    // 业务
    const [desList, setDesList] = useState([]);
    const [bfList, setBfList] = useState([]);
    const [bdList, setBdList] = useState([]);
    const [rmList, setRmList] = useState([]);

    // 功能、界面
    const [sfList, setSfList] = useState([]);
    const [ucList, setUcList] = useState([]);
    const [uiList, setUiList] = useState([]);

    // 数据、接口、程序
    const [dtList, setDtList] = useState([]);
    const [dvList, setDvList] = useState([]);
    const [cdgList, setCdgList] = useState([]);
    const [lsiList, setLsiList] = useState([]);
    const [fcList, setFcList] = useState([]);
    const [dtoList, setDtoList] = useState([]);

    // 组织模型、分析模型
    const [ooList, setOoList] = useState([]);
    const [doList, setDoList] = useState([]);
    const [aoList, setAoList] = useState([]);
    const [aiList, setAiList] = useState([]);
    const [arList, setArList] = useState([]);

    // -----------------------setRows-----------------------
    const [bfMapRows, setBfMapRows] = useState([]);
    const [bizMapRows, setBizMapRows] = useState([]);
    const [dataMapRows, setDataMapRows] = useState([]);
    const [sfMapRows, setSfMapRows] = useState([]);
    const [uiMapRows, setUiMapRows] = useState([]);
    const [infMapRows, setInfMapRows] = useState([]);
    const [fcMapRows, setFcMapRows] = useState([]);
    const [orgMapRows, setOrgMapRows] = useState([]);
    const [anaMapRows, setAnaMapRows] = useState([]);

    // 业务
    const [desRows, setDesRows] = useState([]);
    const [bfRows, setBfRows] = useState([]);
    const [bdRows, setBdRows] = useState([]);
    const [rmRows, setRmRows] = useState([]);

    // 功能、界面
    const [sfRows, setSfRows] = useState([]);
    const [ucRows, setUcRows] = useState([]);
    const [uiRows, setUiRows] = useState([]);

    // 数据、接口、程序
    const [dtRows, setDtRows] = useState([]);
    const [dvRows, setDvRows] = useState([]);
    const [cdgRows, setCdgRows] = useState([]);
    const [lsiRows, setLsiRows] = useState([]);
    const [fcRows, setFcRows] = useState([]);
    const [dtoRows, setDtoRows] = useState([]);

    // 组织模型、分析模型
    const [ooRows, setOoRows] = useState([]);
    const [doRows, setDoRows] = useState([]);
    const [aoRows, setAoRows] = useState([]);
    const [aiRows, setAiRows] = useState([]);
    const [arRows, setArRows] = useState([]);

    // -----------------------Loading-----------------------
    const [bfMapLoading, setBfMapLoading] = useState(false);
    const [bizMapLoading, setBizMapLoading] = useState(false);
    const [dataMapLoading, setDataMapLoading] = useState(false);
    const [sfMapLoading, setSfMapLoading] = useState(false);
    const [uiMapLoading, setUiMapLoading] = useState(false);
    const [infMapLoading, setInfMapLoading] = useState(false);
    const [fcMapLoading, setFcMapLoading] = useState(false);
    const [orgMapLoading, setOrgMapLoading] = useState(false);
    const [anaMapLoading, setAnaMapLoading] = useState(false);

    // 业务
    const [desLoading, setDesLoading] = useState(false);
    const [bfLoading, setBfLoading] = useState(false);
    const [bdLoading, setBdLoading] = useState(false);
    const [rmLoading, setRmLoading] = useState(false);

    // 功能、界面
    const [sfLoading, setSfLoading] = useState(false);
    const [ucLoading, setUcLoading] = useState(false);
    const [uiLoading, setUiLoading] = useState(false);

    // 数据、接口、程序
    const [dtLoading, setDtLoading] = useState(false);
    const [dvLoading, setDvLoading] = useState(false);
    const [cdgLoading, setCdgLoading] = useState(false);
    const [lsiLoading, setLsiLoading] = useState(false);
    const [fcLoading, setFcLoading] = useState(false);
    const [dtoLoading, setDtoLoading] = useState(false);

    // 组织模型、分析模型
    const [ooLoading, setOoLoading] = useState(false);
    const [doLoading, setDoLoading] = useState(false);
    const [aoLoading, setAoLoading] = useState(false);
    const [aiLoading, setAiLoading] = useState(false);
    const [arLoading, setArLoading] = useState(false);

    const options = [
        // -------集成地图-------
        {
            value: 'BF_MAP',
            label: '流程模型',
        },
        // {
        //     value: 'BIZ_MAP',
        //     label: '业务模型',
        // },
        {
            value: 'SF_MAP',
            label: '功能模型',
        },
        {
            value: 'UI_MAP',
            label: '界面模型',
        },
        {
            value: 'INF_MAP',
            label: '接口模型',
        },
        {
            value: 'UC_MAP',
            label: '用例模型',
        },
        {
            value: 'DATA_MAP',
            label: '库表模型',
        },
        {
            value: 'FC_MAP',
            label: '程序模型',
        },

        // -------逻辑图-------
        {
            value: 'DES',
            label: '需求确认单',
        },
        {
            value: 'BF',
            label: '业务流程',
        },
        {
            value: 'RULEMRM',
            label: '知识模块',
        },
        NEWS.includes(ref.current.prjTypeCode) && {
            value: 'BD',
            label: '程序模块',
        },
        // {
        //     value: 'SF',
        //     label: '系统功能',
        // },
        {
            value: 'UC',
            label: '集成用例',
        },
        {
            value: 'UI',
            label: '用户界面',
        },
        {
            value: 'DT',
            label: '数据表',
        },
        {
            value: 'DV',
            label: '数据视图',
        },
        {
            value: 'CDG',
            label: '标准字段组',
        },
        {
            value: 'LSI',
            label: '外联接口',
        },
        {
            value: 'FC',
            label: '程序能力',
        },
        {
            value: 'DTO',
            label: 'DTO',
        },
        OM == ref.current.prjTypeCode && {
            value: 'OO',
            label: '组织对象',
        },
        BAM == ref.current.prjTypeCode && {
            value: 'DO',
            label: '维度对象',
        },
        BAM == ref.current.prjTypeCode && {
            value: 'AO',
            label: '分析对象',
        },
        TAM == ref.current.prjTypeCode && {
            value: 'AMAI',
            label: '分析指标',
        },
        TAM == ref.current.prjTypeCode && {
            value: 'AMAR',
            label: '分析报表',
        },
    ].filter(v => v);

    // check
    // const [checkedList, setCheckedList] = useState(options.map(v => v.value).filter(v => !['BIZ_MAP', 'DATA_MAP', 'SF_MAP', 'UI_MAP', 'INF_MAP', 'FC_MAP'].includes(v)));
    // const [checkedList, setCheckedList] = useState(options.map(v => v.value).filter(v => ['BD', 'OO', 'DO', 'AMAI'].includes(v)));
    // 默认不勾选任何模件类型，由用户自行选择
    const [checkedList, setCheckedList] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);

    useEffect(() => {
        init();
        // 默认不勾选任何模件类型，进页面不自动发起检索
        if (checkedList.length > 0) {
            doSearch(keyword);
        }
    }, []);

    const init = () => {
        ref.current.prjId = user?.currPrjId;
        ref.current.sVer = user?.currPrjSver;
        ref.current.prjTypeCode = user?.prjTypeCode;
        ref.current.subTypeCode = user?.subTypeCode;
        ref.current.keyword = keyword;
        ref.current.searchObj = {};
    }

    // force：用户手动发起检索（点击搜索按钮/回车）时，无视关键字缓存强制重新检索
    const doSearch = async (keyword, force = false) => {
        if (!ref.current.prjId) {
            return;
        }

        if (checkedList.length == 0) {
            return Modal.info({ content: '请选择搜索模件类型' });
        }

        try {
            ref.current.count = 1;
            ref.current.keyword = keyword;
            const dpTypes = checkedList.length > 0 ? checkedList : options.map(v => v.value);

            for (const dpType of dpTypes) {
                doSearchRecord(dpType, keyword, force);
            }
        } catch (err) {
            console.log(err);
        } finally {
        }
    }

    const clearSearch = (searchType) => {
        if (searchType) {
            switch (searchType) {
                // 集成图
                case 'BF_MAP': setBfMapList([]); break;
                case 'BIZ_MAP': setBizMapList([]); break;
                case 'DATA_MAP': setDataMapList([]); break;
                case 'SF_MAP': setSfMapList([]); break;
                case 'UI_MAP': setUiMapList([]); break;
                case 'INF_MAP': setInfMapList([]); break;
                case 'FC_MAP': setFcMapList([]); break;
                case 'ORG_MAP': setOrgMapList([]); break;
                case 'ANA_MAP': setAnaMapList([]); break;
                // 业务
                case 'DES': setDesList([]); break;
                case 'BF': setBfList([]); break;
                case 'BD': setBdList([]); break;
                case 'RULEMRM': setRmList([]); break;
                // 功能、界面
                case 'SF': setSfList([]); break;
                case 'UC': setUcList([]); break;
                case 'UI': setUiList([]); break;
                // 数据
                case 'DT': setDtList([]); break;
                case 'DV': setDvList([]); break;
                case 'CDG': setCdgList([]); break;
                // 接口、程序
                case 'LSI': setLsiList([]); break;
                case 'FC': setFcList([]); break;
                case 'DTO': setDtoList([]); break;
                // 组织、分析
                case 'OO': setOoList([]); break;
                case 'DO': setDoList([]); break;
                case 'AO': setAoList([]); break;
                case 'AMAI': setAiList([]); break;
                case 'AMAR': setArList([]); break;
            }
        } else {
            // 集成图
            setBfMapList([]);
            setBizMapList([]);
            setDataMapList([]);
            setSfMapList([]);
            setUiMapList([]);
            setInfMapList([]);
            setFcMapList([]);
            setOrgMapList([]);
            setAnaMapList([]);

            // 业务
            setDesList([]);
            setBfList([]);
            setBdList([]);
            setRmList([]);

            // 功能、界面
            setSfList([]);
            setUcList([]);
            setUiList([]);

            // 数据
            setDtList([]);
            setDvList([]);
            setCdgList([]);

            // 接口、程序
            setLsiList([]);
            setFcList([]);
            setDtoList([]);

            // 组织、分析
            setOoList([]);
            setDoList([]);
            setAoList([]);
            setAiList([]);
            setArList([]);
        }
    }

    const doSearchRecord = async (searchType, keyword, force = false) => {
        try {
            // 关键字为空
            if (!keyword) {
                ref.current.searchObj[searchType] = null;
                clearSearch(searchType);
                return;
            }

            // begin: 优化查询性能：缓存已经查询的关键字
            console.log(searchType, ref.current.keyword, ref.current.searchObj[searchType]);

            if (!force && ref.current.keyword == ref.current.searchObj[searchType]) {
                console.log('return');
                return;
            }

            ref.current.searchObj[searchType] = keyword; // 缓存之前关键字
            console.log('doSearchRecord');
            // end

            clearSearch(searchType);
            setLoad(searchType, true);

            // 搜索统计
            let result = await doSearchTotal(searchType, keyword);

            let data = [];
            let totalRow = result.totalRow;
            let pageSize = result.pageSize;
            let count = Math.ceil(totalRow / pageSize);

            // 分段检索
            for (var i = 0; i < count; i++) {
                let dataList = await doSearchData(searchType, keyword, i * pageSize);
                data = [...data, ...dataList];

                switch (searchType) {
                    // 集成图
                    case 'BF_MAP': setBfMapList(data); break;
                    case 'BIZ_MAP': setBizMapList(data); break;
                    case 'DATA_MAP': setDataMapList(data); break;
                    case 'SF_MAP': setSfMapList(data); break;
                    case 'UI_MAP': setUiMapList(data); break;
                    case 'INF_MAP': setInfMapList(data); break;
                    case 'FC_MAP': setFcMapList(data); break;
                    case 'ORG_MAP': setOrgMapList(data); break;
                    case 'ANA_MAP': setAnaMapList(data); break;
                    // 业务
                    case 'DES': setDesList(data); break;
                    case 'BF': setBfList(data); break;
                    case 'BD': setBdList(data); break;
                    case 'RULEMRM': setRmList(data); break;
                    // 功能、界面
                    case 'SF': setSfList(data); break;
                    case 'UC': setUcList(data); break;
                    case 'UI': setUiList(data); break;
                    // 数据、接口、程序
                    case 'DT': setDtList(data); break;
                    case 'DV': setDvList(data); break;
                    case 'CDG': setCdgList(data); break;
                    case 'LSI': setLsiList(data); break;
                    case 'FC': setFcList(data); break;
                    case 'DTO': setDtoList(data); break;
                    // 组织、分析
                    case 'OO': setOoList(data); break;
                    case 'DO': setDoList(data); break;
                    case 'AO': setAoList(data); break;
                    case 'AMAI': setAiList(data); break;
                    case 'AMAR': setArList(data); break;
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoad(searchType, false);
        }
    }

    const setLoad = (searchType, loadFlag) => {
        switch (searchType) {
            // 集成图
            case 'BF_MAP': setBfMapLoading(loadFlag); break;
            case 'BIZ_MAP': setBizMapLoading(loadFlag); break;
            case 'DATA_MAP': setDataMapLoading(loadFlag); break;
            case 'SF_MAP': setSfMapLoading(loadFlag); break;
            case 'UI_MAP': setUiMapLoading(loadFlag); break;
            case 'INF_MAP': setInfMapLoading(loadFlag); break;
            case 'FC_MAP': setFcMapLoading(loadFlag); break;
            case 'ORG_MAP': setOrgMapLoading(loadFlag); break;
            case 'ANA_MAP': setAnaMapLoading(loadFlag); break;
            // 需求确认单
            case 'DES': setDesLoading(loadFlag); break;
            case 'BF': setBfLoading(loadFlag); break;
            case 'BD': setBdLoading(loadFlag); break;
            case 'RULEMRM': setRmLoading(loadFlag); break;
            // 功能、界面
            case 'SF': setSfLoading(loadFlag); break;
            case 'UC': setUcLoading(loadFlag); break;
            case 'UI': setUiLoading(loadFlag); break;
            // 数据、接口、程序
            case 'DT': setDtLoading(loadFlag); break;
            case 'DV': setDvLoading(loadFlag); break;
            case 'CDG': setCdgLoading(loadFlag); break;
            case 'LSI': setLsiLoading(loadFlag); break;
            case 'FC': setFcLoading(loadFlag); break;
            case 'DTO': setDtoLoading(loadFlag); break;
            // 组织、分析
            case 'OO': setOoLoading(loadFlag); break;
            case 'DO': setDoLoading(loadFlag); break;
            case 'AO': setAoLoading(loadFlag); break;
            case 'AMAI': setAiLoading(loadFlag); break;
            case 'AMAR': setArLoading(loadFlag); break;
        }
    }

    const doSearchTotal = async (searchType, keyword) => {
        try {
            const data = await runAsync(
                async () => {
                    return await http.post(`/prjs/search`, {
                        searchType,
                        keyword,
                        prjId: ref.current.prjId,
                        sVer: ref.current.sVer,
                        prjPatternId: ref.current.prjPatternId
                    });
                }, {
                error: { content: (err) => `搜索失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });
            return data ?? {};
        } catch (err) {
            console.log(err);
        }
    }

    const doSearchData = async (searchType, keyword, startRow) => {
        try {
            const data = await runAsync(
                async () => {
                    return await http.post(`/prjs/search/data`, {
                        searchType,
                        keyword,
                        startRow,
                        prjId: ref.current.prjId,
                        sVer: ref.current.sVer,
                        prjPatternId: ref.current.prjPatternId
                    });
                }, {
                error: { content: (err) => `搜索失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });
            return data.dataList ?? [];
        } catch (err) {
            console.log(err);
        }
    }

    // 切换项目
    const onChangePrj = () => {
        // if (NEWS.includes(ref.current.prjTypeCode)) {
        //     setCheckedList(['BD']);
        // } else if (OM == ref.current.prjTypeCode) {
        //     setCheckedList(['OO']);
        // } else if (BAM == ref.current.prjTypeCode) {
        //     setCheckedList(['DO']);
        // } else if (TAM == ref.current.prjTypeCode) {
        //     setCheckedList(['AMAI']);
        // } else {
        //     setCheckedList([]);
        // }
        // 默认不勾选任何模件类型
        setCheckedList([]);
    }

    const onCheckAllChange = (e) => {
        setCheckedList(e.target.checked ? options.map(v => v.value) : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
    }

    const onChange = (list) => {
        if (list.length > 2) {
            Modal.info({ content: '最多选择2种类型进行检索' });
        } else {
            setCheckedList(list);
            setIndeterminate(!!list.length && list.length < options.length);
            setCheckAll(list.length === options.length);

            // 初始化
            const clearList = options.filter(v => !list.includes(v.value));
            for (const v of clearList) {
                ref.current.searchObj[v.value] = null;
            }
        }
    }

    const onLoading = () => {
        const isMap = bfMapLoading || bizMapLoading || dataMapLoading || sfMapLoading || uiMapLoading || infMapLoading || fcMapLoading || orgMapLoading || anaMapLoading;
        const isBiz = desLoading || bfLoading || bdLoading || rmLoading;
        const isSf = sfLoading || ucLoading || uiLoading;
        const isData = dtLoading || dvLoading || cdgLoading;
        const isFc = lsiLoading || fcLoading || dtoLoading;
        const isOo = ooLoading || doLoading || aoLoading || aiLoading || arLoading;
        return isMap || isBiz || isSf || isData || isFc || isOo;
    }

    const BadgeExt = ({ name, dataList, loading }) => {
        return (
            <Badge size="small" offset={[loading ? 2 : 10, 0]} count={dataList.length} overflowCount={9999} status={loading ? 'processing' : 'success'}>
                {name}
            </Badge>
        );
    }

    const paneList = [
        <TabPane key={'BF_MAP'} tab={<BadgeExt name="流程模型" dataList={bfMapList} loading={bfMapLoading} />}>
            <BasMapTab param={ref} nodeType={'PM'} dataList={bfMapList} rows={bfMapRows} setRows={setBfMapRows} loading={bfMapLoading} />
        </TabPane>,

        <TabPane key={'BIZ_MAP'} tab={<BadgeExt name="业务模型" dataList={bizMapList} loading={bizMapLoading} />}>
            <BasMapTab param={ref} nodeType={'BM'} dataList={bizMapList} rows={bizMapRows} setRows={setBizMapRows} loading={bizMapLoading} />
        </TabPane>,

        <TabPane key={'DATA_MAP'} tab={<BadgeExt name="库表模型" dataList={dataMapList} loading={dataMapLoading} />}>
            <BasMapTab param={ref} nodeType={'DM'} dataList={dataMapList} rows={dataMapRows} setRows={setDataMapRows} loading={dataMapLoading} />
        </TabPane>,

        <TabPane key={'SF_MAP'} tab={<BadgeExt name="功能模型" dataList={sfMapList} loading={sfMapLoading} />}>
            <BasMapTab param={ref} nodeType={'FM'} dataList={sfMapList} rows={sfMapRows} setRows={setSfMapRows} loading={sfMapLoading} />
        </TabPane>,

        <TabPane key={'UI_MAP'} tab={<BadgeExt name="界面模型" dataList={uiMapList} loading={uiMapLoading} />}>
            <BasMapTab param={ref} nodeType={'UM'} dataList={uiMapList} rows={uiMapRows} setRows={setUiMapRows} loading={uiMapLoading} />
        </TabPane>,

        <TabPane key={'INF_MAP'} tab={<BadgeExt name="接口模型" dataList={infMapList} loading={infMapLoading} />}>
            <BasMapTab param={ref} nodeType={'LS'} dataList={infMapList} rows={infMapRows} setRows={setInfMapRows} loading={infMapLoading} />
        </TabPane>,

        <TabPane key={'FC_MAP'} tab={<BadgeExt name="程序模型" dataList={fcMapList} loading={fcMapLoading} />}>
            <BasMapTab param={ref} nodeType={'VM'} dataList={fcMapList} rows={fcMapRows} setRows={setFcMapRows} loading={fcMapLoading} />
        </TabPane>,

        <TabPane key={'ORG_MAP'} tab={<BadgeExt name="组织模型" dataList={orgMapList} loading={orgMapLoading} />}>
            <BasMapTab param={ref} nodeType={'OM'} dataList={orgMapList} rows={orgMapRows} setRows={setOrgMapRows} loading={orgMapLoading} />
        </TabPane>,

        <TabPane key={'ANA_MAP'} tab={<BadgeExt name="分析模型" dataList={anaMapList} loading={anaMapLoading} />}>
            <BasMapTab param={ref} nodeType={'AM'} dataList={anaMapList} rows={anaMapRows} setRows={setAnaMapRows} loading={anaMapLoading} />
        </TabPane>,

        <TabPane key={'DES'} tab={<BadgeExt name="需求确认单" dataList={desList} loading={desLoading} />}>
            <DesTab param={ref} nodeType={'DES'} dataList={desList} rows={desRows} setRows={setDesRows} loading={desLoading} />
        </TabPane>,

        <TabPane key={'BF'} tab={<BadgeExt name="业务流程" dataList={bfList} loading={bfLoading} />}>
            <BfTab param={ref} dataList={bfList} rows={bfRows} setRows={setBfRows} loading={bfLoading} />
        </TabPane>,

        <TabPane key={'RULEMRM'} tab={<BadgeExt name="知识模块" dataList={rmList} loading={rmLoading} />}>
            <RmTab param={ref} dataList={rmList} rows={rmRows} setRows={setRmRows} loading={rmLoading} />
        </TabPane>,

        <TabPane key={'BD'} tab={<BadgeExt name="程序模块" dataList={bdList} loading={bdLoading} />}>
            <BdTab param={ref} dataList={bdList} rows={bdRows} setRows={setBdRows} loading={bdLoading} />
        </TabPane>,

        // <TabPane key={'SF'} tab={<BadgeExt name="系统功能" dataList={sfList} loading={sfLoading} />}>
        //     <SfTab param={ref} dataList={sfList} rows={sfRows} setRows={setSfRows} loading={sfLoading} />
        // </TabPane>,

        <TabPane key={'UI'} tab={<BadgeExt name="用户界面" dataList={uiList} loading={uiLoading} />}>
            <UiTab param={ref} dataList={uiList} rows={uiRows} setRows={setUiRows} loading={uiLoading} />
        </TabPane>,

        <TabPane key={'LSI'} tab={<BadgeExt name="外联接口" dataList={lsiList} loading={lsiLoading} />}>
            <LsiTab param={ref} dataList={lsiList} rows={lsiRows} setRows={setLsiRows} loading={lsiLoading} />
        </TabPane>,

        <TabPane key={'UC'} tab={<BadgeExt name="集成用例" dataList={ucList} loading={ucLoading} />}>
            <UcTab param={ref} dataList={ucList} rows={ucRows} setRows={setUcRows} loading={ucLoading} />
        </TabPane>,

        <TabPane key={'DT'} tab={<BadgeExt name="数据表" dataList={dtList} loading={dtLoading} />}>
            <DtTab param={ref} dataList={dtList} rows={dtRows} setRows={setDtRows} loading={dtLoading} />
        </TabPane>,

        <TabPane key={'DV'} tab={<BadgeExt name="数据视图" dataList={dvList} loading={dvLoading} />}>
            <DvTab param={ref} dataList={dvList} rows={dvRows} setRows={setDvRows} loading={dvLoading} />
        </TabPane>,

        <TabPane key={'CDG'} tab={<BadgeExt name="标准字段组" dataList={cdgList} loading={cdgLoading} />}>
            <CdgTab param={ref} dataList={cdgList} rows={cdgRows} setRows={setCdgRows} loading={cdgLoading} />
        </TabPane>,

        <TabPane key={'FC'} tab={<BadgeExt name="程序能力" dataList={fcList} loading={fcLoading} />}>
            <FcTab param={ref} dataList={fcList} rows={fcRows} setRows={setFcRows} loading={fcLoading} />
        </TabPane>,

        <TabPane key={'DTO'} tab={<BadgeExt name="DTO" dataList={dtoList} loading={dtoLoading} />}>
            <DtoTab param={ref} dataList={dtoList} rows={dtoRows} setRows={setDtoRows} loading={dtoLoading} />
        </TabPane>,

        <TabPane key={'OO'} tab={<BadgeExt name="组织对象" dataList={ooList} loading={ooLoading} />}>
            <OoTab param={ref} dataList={ooList} rows={ooRows} setRows={setOoRows} loading={ooLoading} />
        </TabPane>,

        <TabPane key={'DO'} tab={<BadgeExt name="维度对象" dataList={doList} loading={doLoading} />}>
            <DoTab param={ref} dataList={doList} rows={doRows} setRows={setDoRows} loading={doLoading} />
        </TabPane>,
        <TabPane key={'AO'} tab={<BadgeExt name="分析对象" dataList={aoList} loading={aoLoading} />}>
            <AoTab param={ref} dataList={aoList} rows={aoRows} setRows={setAoRows} loading={aoLoading} />
        </TabPane>,

        <TabPane key={'AMAI'} tab={<BadgeExt name="分析指标" dataList={aiList} loading={aiLoading} />}>
            <AiTab param={ref} dataList={aiList} rows={aiRows} setRows={setAiRows} loading={aiLoading} />
        </TabPane>,
        <TabPane key={'AMAR'} tab={<BadgeExt name="分析报表" dataList={arList} loading={arLoading} />}>
            <ArTab param={ref} dataList={arList} rows={arRows} setRows={setArRows} loading={arLoading} />
        </TabPane>,
    ].filter(v => checkedList.includes(v.key));

    const searchInput = {
        width: '600px',
        borderRadius: '16px 0 0 16px',
        borderRight: 'none',
    }

    const searchBtn = {
        display: 'inline-block',
        width: '88px',
        height: '40px',
        outline: 0,
        border: '0 none',
        borderRadius: '0 16px 16px 0',
        fontSize: '14px',
        lineHeight: '32px',
        cursor: 'pointer',
        transition: 'all .2s ease -in',
        backgroundColor: '#0099CC',
        textAlign: 'center',
        color: '#fff',
    }

    const cssSearch = {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
    }

    const cssContent = {
        display: 'flex',
        justifyContent: 'center',
        // marginTop: '10px',
        marginLeft: '4px',
    }

    const cssTab = {
        '.ant-tabs-nav': {
            margin: '0 0 0px 0'
        },
    }

    return <div>
        <div css={{ display: 'flex', justifyContent: 'center', marginTop: '20px', fontSize: '12pt', fontWeight: 'bold' }}>
            <div>
                <span>项目：</span>

                {/* <SelectProjectList
                    style={{ width: '400px' }}
                    prjId={ref.current.prjId}
                    onCall={(value) => {
                        ref.current.prjId = value.pkid;
                        ref.current.sVer = value.sVer;
                        ref.current.prjPatternId = null; // 迭代版
                        clearSearch();
                    }}
                /> */}

                {
                    ref.current.prjId && ref.current.sVer &&
                    <>
                        <SelectBaseline
                            param={{ prjId: ref.current.prjId, sVer: ref.current.sVer }}
                            onCall={(value) => {
                                ref.current.prjId = value.pkid;
                                ref.current.sVer = value.sVer;
                                ref.current.prjTypeCode = value.prjTypeCode;
                                ref.current.subTypeCode = value.subTypeCode;
                                ref.current.prjPatternId = null; // 迭代版
                                setPrj(value);
                                onChangePrj();
                            }}
                        />

                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>

                        <span>成品：</span>
                        <SelectPattern
                            style={{ width: '200px' }}
                            prjId={ref.current.prjId}
                            sVer={ref.current.sVer}
                            value={ref.current.prjPatternId}
                            onChange={(value) => {
                                ref.current.prjPatternId = value;
                                clearSearch();
                            }}
                            onCall={(value) => {
                                ref.current.patternRev = value;
                            }}
                        />
                    </>
                }
            </div>
        </div>

        <div css={cssSearch}>
            <Input
                css={searchInput}
                size="large"
                allowClear
                enterButton
                defaultValue={keyword}
                prefix={<SearchOutlined />}
                onChange={e => ref.current.keyword = e.target.value}
                onPressEnter={e => doSearch(e.target.value, true)}
            />
            <Button type="primary" css={searchBtn} onClick={() => doSearch(ref.current.keyword, true)} loading={onLoading()}>搜索</Button>
        </div>

        <div css={cssSearch} style={{ marginTop: '10px' }}>
            {/* <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>全部</Checkbox> */}
            {/* <Checkbox.Group value={checkedList} onChange={onChange} options={options} /> */}
            <Checkbox.Group value={checkedList} onChange={onChange}>
                {
                    NEWS.includes(ref.current.prjTypeCode) &&
                    <>
                        <Row>
                            <Checkbox value="BF_MAP">流程模型</Checkbox>
                            {/* <Checkbox value="BIZ_MAP">业务模型</Checkbox> */}
                            <Checkbox value="SF_MAP">功能模型</Checkbox>
                            <Checkbox value="UI_MAP">界面模型</Checkbox>
                            <Checkbox value="INF_MAP">接口模型</Checkbox>
                            <Checkbox value="UC_MAP">用例模型</Checkbox>
                            <Checkbox value="DATA_MAP">库表模型</Checkbox>
                            <Checkbox value="FC_MAP">程序模型</Checkbox>
                        </Row>

                        <Row>
                            <Checkbox value="DES">需求确认单</Checkbox>
                            <Checkbox value="BF">业务流程</Checkbox>
                            <Checkbox value="RULEMRM">知识模块</Checkbox>
                            <Checkbox value="BD">程序模块</Checkbox>

                            {/* <Checkbox value="SF">系统功能</Checkbox> */}
                            <Checkbox value="UI">用户界面</Checkbox>
                            <Checkbox value="LSI">外联接口</Checkbox>
                            <Checkbox value="UC">集成用例</Checkbox>

                            <Checkbox value="DT">数据表</Checkbox>
                            <Checkbox value="DV">数据视图</Checkbox>
                            <Checkbox value="CDG">标准字段组</Checkbox>

                            <Checkbox value="FC">程序能力</Checkbox>
                            <Checkbox value="DTO">DTO</Checkbox>
                        </Row>
                    </>
                }

                {
                    OM == ref.current.prjTypeCode &&
                    <>
                        <Row>
                            <Checkbox value="ORG_MAP">组织模型</Checkbox>
                            <Checkbox value="OO">组织对象</Checkbox>
                        </Row>
                    </>
                }

                {
                    BAM == ref.current.prjTypeCode &&
                    <Row>
                        <Checkbox value="ANA_MAP">分析模型</Checkbox>
                        <Checkbox value="DO">维度对象</Checkbox>
                        <Checkbox value="AO">分析对象</Checkbox>
                    </Row>
                }

                {
                    TAM == ref.current.prjTypeCode &&
                    <Row>
                        <Checkbox value="ANA_MAP">分析模型</Checkbox>
                        <Checkbox value="AMAI">分析指标</Checkbox>
                        <Checkbox value="AMAR">分析报表</Checkbox>
                    </Row>
                }
            </Checkbox.Group>
        </div>

        {
            (0 == ref.current.count) ?
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>请按“回车”键发起检索</div>
                :
                <div css={cssContent}>
                    <Tabs type="list" tabPosition={'top'} size="large" css={cssTab}>
                        {
                            paneList.map(v => v)
                        }
                    </Tabs>
                </div>
        }
    </div >;
}

export default Pane;
